import { TabView, TabPanel } from "primereact/tabview";
import { problemStatusTabs } from "../../utils/problemConstants";

// Tab headers as one rounded bar (segmented control): the four tabs are joined and share the full width,
// the active tab is filled. No line under the tabs.
const segmentedTabsClassName = [
  "[&_.p-tabview-nav-content]:!bg-transparent",
  "[&_.p-tabview-ink-bar]:!hidden",
  "[&_.p-tabview-nav]:!border-0",
  "[&_.p-tabview-nav]:!bg-slate-100",
  "[&_.p-tabview-nav]:!rounded-lg",
  "[&_.p-tabview-nav]:!p-1",
  "[&_.p-tabview-nav]:!gap-1",
  "[&_.p-tabview-nav_li]:!flex-1",
  "[&_.p-tabview-nav-link]:!w-full",
  "[&_.p-tabview-nav-link]:!justify-center",
  "[&_.p-tabview-nav-link]:!rounded-md",
  "[&_.p-tabview-nav-link]:!border-0",
  "[&_.p-tabview-nav-link]:!bg-transparent",
  "[&_.p-tabview-nav-link]:!text-slate-500",
  "[&_.p-tabview-nav-link]:!px-2",
  "[&_.p-tabview-nav-link]:!py-2",
  "[&_.p-tabview-nav-link]:!m-0",
  "[&_li.p-highlight_.p-tabview-nav-link]:!bg-indigo-500",
  "[&_li.p-highlight_.p-tabview-nav-link]:!text-white",
  "[&_.p-tabview-panels]:!pt-4",
].join(" ");

// The tabs of the problem page: one per status of a problem (baru / schedule / solved / ignore).
// The content (filter and the list of that status) is only rendered for the active tab.
//   status: status of the active tab, onChangeStatus(status): another tab was picked
//   statusCounts: { status: number of problems } (null while the data is not pulled), the tabs with alertCount show it
const ProblemStatusTabs = ({
  status,
  onChangeStatus,
  statusCounts,
  children,
}) => {
  const activeIndex = problemStatusTabs.findIndex((el) => el.status === status);

  return (
    <TabView
      className={`elevated-card-tight-vertical w-100 ${segmentedTabsClassName}`}
      activeIndex={activeIndex}
      onTabChange={(e) => onChangeStatus(problemStatusTabs[e.index].status)}
    >
      {problemStatusTabs.map((tab) => (
        <TabPanel
          key={tab.status}
          className={`col-start-start gap-4`}
          header={
            <span className="row-center-center gap-2">
              {tab.label}
              {tab.alertCount && statusCounts && statusCounts[tab.status] > 0 && (
                <span
                  className="row-center-center rounded-full bg-red-500 px-1.5 min-w-[1.25rem] h-5 text-xs font-bold text-white"
                  title={`${statusCounts[tab.status]} problem`}
                >
                  {statusCounts[tab.status]}
                </span>
              )}
            </span>
          }
        >
          {tab.status === status && children}
        </TabPanel>
      ))}
    </TabView>
  );
};

export default ProblemStatusTabs;
